"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ activeDelivery, addressData, }) {
    if (activeDelivery.user_delivery_id !== addressData.id) {
        return false;
    }
    const addressDataKeyArr = [
        'name',
        'phone',
        'phone_code',
        'post_code',
        'address',
        'address_detail',
        'en_address',
        'en_address_detail',
    ];
    let isActiveAddress = true;
    addressDataKeyArr.forEach(key => {
        if (activeDelivery[key] !== addressData[key]) {
            isActiveAddress = false;
            return false;
        }
    });
    return isActiveAddress;
}
exports.default = default_1;
